export default __webpack_public_path__ + "static/media/pavlosv.ecea6af8.svg";